/**
 * O texto da regra de preço do plantão — "R$ 180/atendimento", "R$ 280/hora", "1ª hora R$ 250 + demais R$ 150".
 *
 * UM lugar só: o servidor escreve a coluna "Regra do contrato" (`regraTexto`) e a tela mostra as regras em conflito no
 * "Escolher regra" com este mesmo texto. Duas cópias concordariam por meses e divergiriam no primeiro ajuste de formato
 * (achado na construção da aba, 06/10/2026). A direção da casa: o servidor importa do front.
 */
import type { RegraDePreco } from './plantao-tipos';

const reaisCurtos = (c: number | null) =>
  c === null
    ? '—'
    : `R$ ${(c / 100).toLocaleString('pt-BR', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;

export function textoDoPreco(p: RegraDePreco): string {
  if (p.modo === 'por_chamado') return `${reaisCurtos(p.valorCentavos)}/atendimento`;
  if (p.modo === 'por_hora') return `${reaisCurtos(p.valorCentavos)}/hora`;
  return `1ª hora ${reaisCurtos(p.primeiraHoraCentavos)} + demais ${reaisCurtos(p.demaisCentavos)}`;
}
